// 明細docの配列から、カート(order_id)単位の「見出し」オブジェクトを作る純関数。
//
// ordersコレクションは 1ドキュメント = 商品1行 で、同じカートの明細は
// 発注担当者・発注部署・納入先といったカート共通の情報を全明細が同じ値で持っている。
// ここではカートごとに最初の1件を代表として、そのカート共通の項目だけを抜き出す。
//
// かつて同じ抽出リストが components/OrderProcessing/table/TableArea.jsx と
// pages/OrderHistory.jsx に個別に書かれており(34項目のコピー)、
// 片方にだけ項目を足すと画面ごとに表示が食い違う状態だった。ここに一本化する。
//
// ★重要: このオブジェクトは「カート単位」なので、明細ごとに値が異なる項目
//   (id / status / order_number / placed_at / ordered_at / received_at / canceled_at)は
//   意図的に含めていない。含めると「カート内の最初の1件の状態」が
//   カート全体の状態であるかのように表示されてしまう。
//   明細単位の情報が必要な画面は fetchOrdersHistoryByOrder で明細docを取り直すこと
//   (components/products/OrderHistoryItem.jsx がその実装)。

// カート共通の項目(この順序で抽出する)
export const ORDER_HEADER_FIELDS = [
  "order_id",
  "login_user_uid",
  "login_user_dep_id",
  "login_user_dep_name",
  "login_user_email",
  "login_user_id",
  "login_user_name",
  "login_user_role",
  "order_user_id",
  "order_user_name",
  "order_user_dep_id",
  "order_user_dep_name",
  "order_user_email",
  "order_base_id",
  "order_base_name",
  "order_department_id",
  "order_department_name",
  "billing_user_flg",
  "billing_user_id",
  "billing_user_name",
  "billing_user_dep_id",
  "billing_user_dep_name",
  "billing_company_flg",
  "billing_company_id",
  "billing_company_name_full",
  "billing_company_name",
  "remark_on_order",
  "delivery_office_id",
  "delivery_office_name",
  "delivery_office_address_main",
  "delivery_office_address_sub",
  "delivery_office_tell",
  "delivery_department",
  "amount",
];

const pickHeaderFields = (order) =>
  ORDER_HEADER_FIELDS.reduce(
    (acc, field) => ({ ...acc, [field]: order[field] }),
    {}
  );

// orders … 明細docの配列
// targetOrderNumber … 指定した場合、その注文番号を含むカートだけを返す(注文履歴の絞り込み用)
export const createOrderList = (orders, targetOrderNumber) => {
  const uniqueOrdersMap = new Map();

  (orders || []).forEach((order) => {
    if (!order) {
      return;
    }
    if (
      targetOrderNumber &&
      Number(order.order_number) !== Number(targetOrderNumber)
    ) {
      return;
    }
    const orderId = order.order_id;
    if (!uniqueOrdersMap.has(orderId)) {
      uniqueOrdersMap.set(orderId, pickHeaderFields(order));
    }
  });

  return Array.from(uniqueOrdersMap.values());
};

export default createOrderList;
